import React from 'react';

interface CircleInitialProps {
    text: string;
}

export const CircleInitial: React.FC<CircleInitialProps> = ({ text }) => {
    const initial = text?.charAt(0) || '?';

    // 문자열을 해시값으로 변환하는 함수
    const stringToHash = (str: string) => {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            const char = str.charCodeAt(i);
            hash = ((hash << 5) - hash) + char;
            hash = hash & hash;
        }
        return hash;
    };

    // 해시값을 HSL 색상으로 변환
    const getColorFromString = (str: string) => {
        const hash = Math.abs(stringToHash(str));
        const hue = hash % 360; // 0-360 색상
        const saturation = 35; // 채도
        const lightness = 85; // 명도
        return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    };

    const backgroundColor = getColorFromString(text);
    const textColor = '#333'; // 텍스트는 항상 흰색으로

    return (
        <div
            style={{
                width: '20px',
                height: '20px',
                borderRadius: '50%',
                backgroundColor,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '12px',
                color: textColor,
                fontWeight: 500,
            }}
        >
            {initial}
        </div>
    );
};